import { render } from "./BlueDocumentIcon.vue?vue&type=template&id=0df658c4&scoped=true&ts=true&lang=pug"
import script from "./BlueDocumentIcon.vue?vue&type=script&lang=ts"
export * from "./BlueDocumentIcon.vue?vue&type=script&lang=ts"

import "./BlueDocumentIcon.vue?vue&type=style&index=0&id=0df658c4&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df658c4"]])

export default __exports__